import {toast} from 'sonner';

import {Modifier} from 'modules/modifier/types';

import {localStorageKey} from 'core/constants';
import {getModifiers} from 'modules/modifier/utils';
import {isWebViewApp} from 'core/utils/webView';

const withDevServiceWorker = !!localStorage.getItem(localStorageKey.WithDevServiceWorker);
let broadcastChannel: BroadcastChannel | null = null;

const createDevBroadcastChannel = () => {
  const channel = new BroadcastChannel('dev-service-worker');
  channel.addEventListener('message', event => {
    const {type, payload} = event.data;

    if (type === 'INFO') {
      toast.info(payload);
    }

    if (type === 'REQUEST') {
      toast.info(
        <div>
          Request <strong>{payload}</strong> was modified
        </div>
      );
    }
  });

  return channel;
};

export const initServiceWorker = () => {
  if (isWebViewApp()) {
    return;
  }

  if (!('serviceWorker' in navigator)) {
    return;
  }

  if (withDevServiceWorker) {
    return registerDevServiceWorker();
  }

  return registerServiceWorker();
};

export const updateModifiers = (payload: Modifier[] = getModifiers()) => {
  broadcastChannel?.postMessage({
    payload,
    type: 'UPDATE_MODIFIERS',
  });
};

export const unregisterServiceWorker = async () => {
  const registration = await navigator.serviceWorker.getRegistration('/');
  return registration?.unregister();
};

export const registerDevServiceWorker = async () => {
  broadcastChannel = createDevBroadcastChannel();
  await navigator.serviceWorker.register('/devServiceWorker.js', {
    scope: '/',
  });
  await navigator.serviceWorker.ready;
  updateModifiers();
};

export const registerServiceWorker = async () => {
  broadcastChannel?.close();
  await navigator.serviceWorker.register('/serviceWorker.js', {
    scope: '/',
  });
};

export const isDevServiceWorker = async () => {
  const registration = await navigator.serviceWorker.getRegistration('/');
  return !!registration?.active?.scriptURL.endsWith('/devServiceWorker.js');
};
